import { useState } from "react";
import Layout from '../components/Layout';

const appointments = [
  { id: 1, patient: "Jane Brown", doctor: "Dr. Lewis", date: "2025-04-10", time: "10:00 AM", status: "upcoming" },
  { id: 2, patient: "Daniel Scott", doctor: "Dr. Chan", date: "2025-03-20", time: "1:00 PM", status: "missed" },
  { id: 3, patient: "Amara Reid", doctor: "Dr. Lee", date: "2025-03-01", time: "3:30 PM", status: "completed" },
  { id: 4, patient: "Kevin James", doctor: "Dr. Lewis", date: "2025-02-18", time: "2:00 PM", status: "rescheduled" },
  { id: 5, patient: "Sasha Morgan", doctor: "Dr. Chan", date: "2025-02-01", time: "9:30 AM", status: "canceled" },
];

export default function Appointments() {
  const [filter, setFilter] = useState("");
  const [selectedAction, setSelectedAction] = useState(null);

  const filteredAppointments = appointments.filter(app =>
    app.status.toLowerCase().includes(filter.toLowerCase()) ||
    app.patient.toLowerCase().includes(filter.toLowerCase())
  );

  return (
    <Layout>
      <div className="p-6 space-y-4">
        <h1 className="text-2xl font-bold">Appointments</h1>

        <input
          type="text"
          placeholder="Search by patient or status..."
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          className="border p-2 rounded w-full md:w-1/2"
        />

        <div className="overflow-x-auto bg-white p-6 rounded-lg  shadow-lg"> 
{/* 
        <div className="bg-white p-6 rounded-lg w-full max-w-3xl max-h-[90vh] overflow-y-auto shadow-lg"> */}
          <table className="w-full mt-4 text-sm text-left border">
            <thead className="bg-gray-100">
              <tr>
                <th className="p-2 border">Patient</th>
                <th className="p-2 border">Doctor</th>
                <th className="p-2 border">Date</th>
                <th className="p-2 border">Time</th>
                <th className="p-2 border">Status</th>
                <th className="p-2 border">Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredAppointments.map(app => (
                <tr key={app.id} className="hover:bg-gray-50">
                  <td className="p-2 border">{app.patient}</td>
                  <td className="p-2 border">{app.doctor}</td>
                  <td className="p-2 border">{app.date}</td>
                  <td className="p-2 border">{app.time}</td>
                  <td className="p-2 border capitalize">{app.status}</td>
                  <td className="p-2 border space-x-2">
                    <button className="bg-blue-600 text-white px-2 py-1 rounded" onClick={() => setSelectedAction({ type: 'reschedule', app })}>Reschedule</button>
                    <button className="bg-red-500 text-white px-2 py-1 rounded" onClick={() => setSelectedAction({ type: 'cancel', app })}>Cancel</button>
                    <button className="bg-yellow-500 text-white px-2 py-1 rounded" onClick={() => setSelectedAction({ type: 'notify', app })}>Notify</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {selectedAction && (
          <div className="fixed inset-0 z-50 bg-black bg-opacity-40 flex items-center justify-center">
            <div className="bg-white p-6 rounded shadow w-full max-w-md">
              <h2 className="text-xl font-semibold mb-4 capitalize">{selectedAction.type} Appointment</h2>
              <p className="text-sm mb-4">Patient: <strong>{selectedAction.app.patient}</strong></p>
              <p className="text-sm mb-4">Doctor: <strong>{selectedAction.app.doctor}</strong></p>
              {selectedAction.type === 'reschedule' && (
                <div className="space-y-2">
                  <input type="date" className="w-full border p-2 rounded" />
                  <input type="time" className="w-full border p-2 rounded" />
                </div>
              )}
              {selectedAction.type === 'notify' && (
                <textarea placeholder="Enter message..." className="w-full border p-2 rounded" rows="4"></textarea>
              )}
              <div className="flex justify-end gap-2 mt-4">
                <button className="bg-gray-300 px-4 py-2 rounded" onClick={() => setSelectedAction(null)}>Close</button>
                <button className="bg-green-600 text-white px-4 py-2 rounded">Confirm</button>
              </div>
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
}
